import React, { useState } from 'react';
import { usePortalContext } from '../../context/PortalContext';

function getWorkspaceName(ws) {
  return (
    ws?.qualification?.animal?.name ||
    ws?.qualification?.legal?.companyName ||
    ws?.qualification?.minor?.name ||
    ws?.qualification?.estate?.name ||
    ws?.qualification?.physical?.name ||
    ws?.name ||
    ws?.fullName ||
    ws?.contact?.name ||
    'Representado'
  );
}

function getWorkspaceIcon(ws) {
  const raw = String(ws?.type || ws?.nature || '').toLowerCase();
  if (raw.includes('animal')) return 'fas fa-paw';
  if (raw.includes('empresa') || raw.includes('pj') || raw.includes('jurídica') || raw.includes('juridica')) return 'fas fa-building';
  if (raw.includes('espolio') || raw.includes('espólio')) return 'fas fa-scroll';
  return 'fas fa-id-card';
}

export default function WorkspaceSelector() {
  const { workspaces, crmClient, humanProfile, setCrmClient } = usePortalContext();
  const [open, setOpen] = useState(false);

  if (!workspaces || workspaces.length === 0) return null;

  const isInWorkspace = crmClient && humanProfile && crmClient.id !== humanProfile.id;
  const activeWorkspace = isInWorkspace ? crmClient : null;

  return (
    <div className="px-2 mt-1">
      {/* Section header */}
      <div className="px-2 mb-2 flex items-center gap-2">
        <span className="text-[10px] font-extrabold uppercase tracking-widest text-gray-300 leading-none truncate">
          Meus Representados
        </span>
        <span className="flex-1 h-px bg-white/10" />
      </div>

      {/* Active workspace indicator */}
      {isInWorkspace && (
        <div className="mb-1.5 px-3 py-1.5 rounded-md bg-[#C5A059]/15 border border-[#C5A059]/30 flex items-center gap-2">
          <i className={`${getWorkspaceIcon(activeWorkspace)} text-[#C5A059] text-[10px] w-3 text-center`} aria-hidden="true" />
          <span className="text-[10px] font-bold text-[#C5A059] truncate flex-1">
            {getWorkspaceName(activeWorkspace)}
          </span>
          <span className="text-[8px] uppercase tracking-wider text-[#C5A059]/70 font-bold shrink-0">ativo</span>
        </div>
      )}

      {/* Workspace list (collapsible) */}
      <div className="space-y-0.5">
        {/* Return to own profile */}
        {isInWorkspace && humanProfile && (
          <button
            type="button"
            onClick={() => setCrmClient(humanProfile)}
            className="group w-full text-left flex items-center gap-3 px-3 py-2 rounded-md transition-colors text-gray-400 hover:bg-white/5 hover:text-white"
          >
            <i className="fas fa-user-circle w-3.5 text-center text-gray-400 group-hover:text-[#C5A059]" aria-hidden="true" />
            <span className="text-xs font-medium truncate flex-1">Voltar ao meu perfil</span>
          </button>
        )}

        {/* Workspace items */}
        {workspaces.map((ws, idx) => {
          const isActive = crmClient?.id === ws.id;
          return (
            <button
              key={ws?.id || idx}
              type="button"
              onClick={() => setCrmClient(ws)}
              className={
                'group w-full text-left flex items-center gap-3 px-3 py-2 rounded-md relative overflow-hidden transition-colors ' +
                (isActive
                  ? 'bg-[#C5A059] text-[#20243B] shadow-md font-bold'
                  : 'text-gray-400 hover:bg-white/5 hover:text-white')
              }
            >
              <i
                className={`${getWorkspaceIcon(ws)} w-3.5 text-center ${isActive ? 'text-[#20243B]' : 'text-gray-400 group-hover:text-[#C5A059]'}`}
                aria-hidden="true"
              />
              <span className="text-xs font-medium truncate flex-1">{getWorkspaceName(ws)}</span>
              {isActive && (
                <i className="fas fa-chevron-right text-[10px] opacity-50 text-[#20243B]" aria-hidden="true" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
